module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data"
  }, [_c('div', {
    staticClass: "school-data__header"
  }, [_c('div', {
    staticClass: "school-data__header__left"
  }, [_c('h1', [_vm._v("Fraværstyper fordelt over måneder")]), _vm._v(" "), _c('changeSchoolYear', {
    staticClass: "marg-1-right",
    attrs: {
      "white-theme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "school-data__header__right"
  }, [(!_vm.isDatesPristine) ? _c('p', {
    staticClass: "d-link",
    on: {
      "click": _vm.resetDates
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.reset')))]) : _vm._e(), _vm._v(" "), _c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1)]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Snup en kop kaffe, det kan tage et par minutter")])], 1) : [_c('div', {
    staticClass: "compare"
  }, [_c('label', {
    staticClass: "compare__toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isComparing),
      expression: "isComparing"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isComparing) ? _vm._i(_vm.isComparing, null) > -1 : (_vm.isComparing)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isComparing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isComparing = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isComparing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isComparing = $$c
        }
      }, _vm.readPreviousYearEvents]
    }
  }), _vm._v("\n        Sammenlign med året før\n      ")]), _vm._v(" "), (_vm.isComparing) ? _c('div', {
    staticClass: "compare__chart"
  }, [(_vm.isLoadingPreviousYear) ? _c('Loader') : _c('LineChart', {
    attrs: {
      "chart-data": _vm.comparisonChartData,
      "options": _vm.chartOptions
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Årsag")]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
    return _c('th', {
      key: monthData.month
    }, [_vm._v(_vm._s(monthData.month))])
  })], 2)]), _vm._v(" "), _c('tbody', [_vm._l((_vm.visibleAbsenceTypes), function(type) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "icon__bg-circle",
      on: {
        "click": function($event) {
          return _vm.toggleHiddenAbsence(type)
        }
      }
    }, [_c('svg', {
      staticClass: "tw-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M12 15a3 3 0 100-6 3 3 0 000 6z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z",
        "clip-rule": "evenodd"
      }
    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(type))]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
      return _c('td', {
        key: monthData.month
      }, [_vm._v("\n        " + _vm._s(monthData[type]) + "\n      ")])
    })], 2)
  }), _vm._v(" "), (_vm.hiddenAbsenceTypes.length > 0) ? _c('tr', {
    staticClass: "toggler",
    on: {
      "click": function($event) {
        _vm.showHidden = !_vm.showHidden
      }
    }
  }, [_c('td', {
    attrs: {
      "colspan": 2 + (_vm.restructuredAbsenceData.length * 1)
    }
  }, [(!_vm.showHidden) ? _c('p', {
    staticClass: "hidden-toggler"
  }, [_c('span', {
    staticClass: "icon-arrow-right4"
  }), _vm._v("Vis skjulte årsager (" + _vm._s(_vm.hiddenAbsenceTypes.length) + ")")]) : _c('p', {
    staticClass: "hidden-toggler"
  }, [_c('span', {
    staticClass: "icon-arrow-down4"
  }), _vm._v("Skjul skjulte årsager")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hiddenAbsenceTypes), function(type) {
    return (_vm.showHidden) ? _c('tr', [_c('td', [_c('div', {
      staticClass: "icon__bg-circle",
      on: {
        "click": function($event) {
          return _vm.toggleHiddenAbsence(type)
        }
      }
    }, [_c('svg', {
      staticClass: "tw-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
      }
    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(type))]), _vm._v(" "), _vm._l((_vm.restructuredAbsenceData), function(monthData) {
      return _c('td', {
        key: monthData.month
      }, [_vm._v("\n          " + _vm._s(monthData[type]) + "\n        ")])
    })], 2) : _vm._e()
  })], 2)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0c4a276!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolDataAbsence.vue
// module id = 2158
// module chunks = 1